import { defineMessage } from 'services/localization';

export const messages = {
    doneButtonText: defineMessage('send'),
    phoneTitle: defineMessage('phone_number'),
    descriptionTitle: defineMessage('description'),
    popupTitle: defineMessage('contact_sales_2'),
    doneButtonTitle: defineMessage('send_the_sales_request'),
    validationErrorRequired: defineMessage('please_fill_in_the_required_fields'),
    createTicketSuccess: defineMessage('your_request_has_been_s_ill_contact_you_shortly'),
    createTicketFail: defineMessage('oops_something_went_wrong_1'),
    phonePlaceholder: defineMessage('enter_phone_number'),
    descriptionPlaceholder: defineMessage('please_submit_your_requ__a_sales_representative'),
};
